/*
 * The keys that distinguish pickup and drop-off locations of a trip.
 * These keys can be used as dynamic prefixes for location fields of a trip schema.
 *
 * "PUDO" = "Pickup/Drop-Off"
 */
export const PUDO_LOCATION_KEYS = Object.freeze({
  PICKUP: 'pickup',
  DROP_OFF: 'dropOff',
});
